
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questions/[id]",
      function () {
        return require("private-next-pages/questions/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/questions/[id]"])
      });
    }
  